// Router table for the web client. Mirrors the mobile `go_router` table
// (apps/mobile/lib/app/router.dart) but for the Phase 8 surface.
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import { AppLayout } from './AppLayout';
import { RedirectIfAuthenticated, RequireAuth } from './guards';
import { LoginScreen } from '@/features/auth/LoginScreen';
import { RegisterScreen } from '@/features/auth/RegisterScreen';
import { ForgotPasswordScreen } from '@/features/auth/ForgotPasswordScreen';
import { ResetPasswordScreen } from '@/features/auth/ResetPasswordScreen';
import { VerifyEmailScreen } from '@/features/auth/VerifyEmailScreen';
import { HomeScreen } from '@/features/home/HomeScreen';
import { WorkspaceScreen } from '@/features/workspace/WorkspaceScreen';
import { ReportListScreen } from '@/features/reports/ReportListScreen';
import { ReportDetailScreen } from '@/features/reports/ReportDetailScreen';
import { ReportEditorScreen } from '@/features/reports/ReportEditorScreen';
import { PhotosScreen } from '@/features/reports/PhotosScreen';
import { ProfileScreen } from '@/features/profile/ProfileScreen';
import { SubscriptionScreen } from '@/features/subscription/SubscriptionScreen';
import { FriendsScreen } from '@/features/social/FriendsScreen';
import { SharesScreen } from '@/features/social/SharesScreen';
import { SharedReportScreen } from '@/features/social/SharedReportScreen';
import { NotFoundScreen } from '@/features/notfound/NotFoundScreen';

function GuardedAppLayout() {
  return (
    <RequireAuth>
      <AppLayout />
    </RequireAuth>
  );
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <RedirectIfAuthenticated />,
    children: [{ index: true, element: <Navigate to="/login" replace /> }],
  },
  {
    element: <RedirectIfAuthenticated />,
    children: [
      { path: '/login', element: <LoginScreen /> },
      { path: '/register', element: <RegisterScreen /> },
      { path: '/forgot-password', element: <ForgotPasswordScreen /> },
      { path: '/reset-password', element: <ResetPasswordScreen /> },
      { path: '/verify-email', element: <VerifyEmailScreen /> },
    ],
  },
  {
    element: <GuardedAppLayout />,
    children: [
      { path: '/home', element: <HomeScreen /> },
      { path: '/workspace', element: <WorkspaceScreen /> },
      { path: '/reports', element: <ReportListScreen /> },
      { path: '/reports/new', element: <ReportEditorScreen /> },
      { path: '/reports/:id', element: <ReportDetailScreen /> },
      { path: '/reports/:id/edit', element: <ReportEditorScreen /> },
      { path: '/reports/:id/photos', element: <PhotosScreen /> },
      { path: '/profile', element: <ProfileScreen /> },
      { path: '/subscription', element: <SubscriptionScreen /> },
      { path: '/friends', element: <FriendsScreen /> },
      { path: '/shares', element: <SharesScreen /> },
    ],
  },
  // Public — does not require auth, although friends-shares will still
  // request an authenticated resolve. This lets the shared link be
  // opened by anyone holding the token.
  { path: '/shared/reports/:id', element: <SharedReportScreen /> },
  { path: '*', element: <NotFoundScreen /> },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
